import { onDocumentReady } from "@story/story_assets/utils";
import { Modal } from "@story/story_assets/modal/modal";


let IDLE_DELAY = 60;

class IdleTimer {
	constructor(delay, action) {
		this.delay = delay;
		this.action = action;

		this.timer = null;
		this.time = 0;

		for (let eventName of ["mousemove", "keypress", "click", "scroll", "touchstart", "touchmove", "touchend"]) {
			document.addEventListener(eventName, this.reset.bind(this), { passive: true });
		}

		this.start();
	}

	reset() {
		// this.time = 0;
	}

	tick() {
		this.time += 1;
		if (this.delay < this.time) {
			this.stop();
			this.action();
		}
	}

	start() {
		this.stop();
		this.timer = setInterval(this.tick.bind(this), 1000);
	}

	stop() {
		if (this.timer) {
			clearInterval(this.timer);
			this.timer = null;
		}
	}
}

onDocumentReady(function() {
	new IdleTimer(IDLE_DELAY, function() {
		Modal.get(document.getElementById("modal-ebook")).open();
	});
});
